import { useMutation } from '@apollo/react-hooks';
import { DEPRECATE_ARTICLES_MUTATION, kmsClient } from 'api';
import {
  DeprecateArticlesMutation,
  DeprecateArticlesMutation_deprecateArticles_articles,
  DeprecateArticlesMutationVariables
} from './__generated__/DeprecateArticlesMutation';

type MutationProps = {
  onStart?: (variables: DeprecateArticlesMutationVariables) => void;
  onCompleted?: (articles: DeprecateArticlesMutation_deprecateArticles_articles[]) => void;
  onError?: (errors: string[]) => void;
};

export const useDeprecateArticles = ({
  onStart,
  onCompleted,
  onError
}: MutationProps): [(variables: DeprecateArticlesMutationVariables) => void, { loading: boolean }] => {
  const [deprecateArticles, { loading }] = useMutation<DeprecateArticlesMutation, DeprecateArticlesMutationVariables>(
    DEPRECATE_ARTICLES_MUTATION,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.deprecateArticles?.errors?.length) {
          if (onError) onError(data.deprecateArticles.errors);
        } else {
          if (onCompleted && data.deprecateArticles?.articles) onCompleted(data.deprecateArticles.articles);
        }
      },
      onError: (error) => onError && onError([error.message])
    }
  );

  return [
    (variables: DeprecateArticlesMutationVariables) => {
      if (onStart) onStart(variables);
      deprecateArticles({ variables });
    },
    { loading }
  ];
};
